const read =  async (reader) => {
	const { default: JSZip } = await import(/* webpackChunkName: "jszip" */'jszip');	
	const zip = await JSZip.loadAsync( reader.blob );
	
	return zip;
}

// see https://stuk.github.io/jszip/documentation/api_zipobject.html
class ZipEntry {
	constructor({ name, dir, date }) {
		this.name = name;
		this.dir = dir;
		this.date = date;
	}
	
	getName() {
		return this.name;
	}
	
	isDirectory() {
		return this.dir;
	}
	
	getDate() {
		return this.date;
	}

}

const zip_reader = async(reader) => {
	const zip = await read( reader );
	
	const entries = [];    
	zip.forEach((relativePath, file) => {
		entries.push( new ZipEntry( file ) );
	});
		
	return entries; 
}

export {
	read,
	zip_reader
}